import { useEffect } from 'react';

const SUFFIX = 'Twin Turbo';

/**
 * Names the current screen in the browser tab and in history.
 *
 * A single-page app keeps whatever title the HTML shipped with unless something changes it, so
 * every screen would otherwise be called «Twin Turbo — заправка с доставкой». That is only a
 * cosmetic problem until somebody has three tabs open, or reaches for browser history to get
 * back to their car list — which is a thing people do on the web and cannot do on a phone.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · ${SUFFIX}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
